import { mobileMenu } from './components/mobileMenu';
import { desktopMenu } from './components/desktopMenu';
import { parallax } from './components/parallax';
import { gforms } from './components/gforms';
import { animations } from './components/animations';
import { alignFull } from './components/alignFull';
import { gallery } from './components/gallery';
import { responsiveEmbeds } from './components/responsiveEmbeds';
import { search, closeSearch } from './components/search';
import { loadMore } from './components/loadMore';
import { coverPoster } from './components/coverPoster';
import { videoButton } from './components/videoButton';
import { projectCarousel } from './components/projectCarousel';
import { textScroller } from './components/textScroller';
import { projectFilters } from './components/projectFilters';
import { globalCta } from './components/globalCta';
import { videoGallery } from './components/videoGallery';
// import { unSplash } from './components/unSplash';

global.$ = global.jQuery;

$(() => {
  console.log('is working?');
  globalCta();
  mobileMenu();
  desktopMenu();
  gforms();
  // unSplash();
  videoGallery();
  loadMore();
  gallery();
  textScroller();
  projectCarousel();
  projectFilters();
  videoButton();
  coverPoster();
  responsiveEmbeds();
  search();
  alignFull();

  //FX GO LAST
  animations();
  parallax();

  // close open things on escape
  window.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') {
      closeSearch();
    }
  });
});
